import { useEffect, useState } from "react";
import { api } from "./api";

let cached = null;
let pending = null;
const load = () => {
  if (!pending) pending = api.get("/product-prices").then((r) => (cached = r.data || [])).catch(() => (cached = []));
  return pending;
};

export const refreshPublishedPrices = () => { cached = null; pending = null; };

export const usePublishedPrices = () => {
  const [list, setList] = useState(cached || []);
  const [ready, setReady] = useState(!!cached);
  useEffect(() => {
    let on = true;
    load().then((l) => { if (on) { setList(l); setReady(true); } });
    return () => { on = false; };
  }, []);
  return Object.assign(Object.fromEntries(list.map((p) => [p.key, p])), { __ready: ready });
};

export const UNIT_LABELS = { per_stuk: "per stuk", per_m2: "per m²", per_project: "per project" };
// Bij elke gepubliceerde prijs staat per onderdeel of het wel of niet is inbegrepen.
export const INCLUDE_LABELS = {
  demontage: "Demontage oude kozijnen", afvoer: "Afvoer oude materialen", levering: "Levering", glas: "Glas",
  montage: "Montage", afwerking_binnen: "Binnenafwerking", afwerking_buiten: "Buitenafwerking",
};
export const GLASS_LABELS = { hr_plus_plus: "HR++ glas", hr_triple: "HR+++ (triple) glas", keuze: "HR++ of HR+++ glas naar keuze" };
export const VAT_LABELS = { incl: "inclusief 21% btw", excl: "exclusief btw" };

const eur = (n) => new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
export const formatPrice = (p) => (p.mode === "range" ? `${eur(p.price_from)} – ${eur(p.price_to)}` : `Vanaf ${eur(p.price_from)}`);
export const nlDate = (iso) => (iso ? new Date(iso).toLocaleDateString("nl-NL", { day: "numeric", month: "long", year: "numeric" }) : "");
